import React from 'react';
import './App.css';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import PhoneAuth from './components/PhoneAuth';
import Login from './components/PhoneLogin';
// import Home from './components/Home';
import Enquiry1 from './components/Enquiry-1';
import Enquiry2 from './components/Enquiry-2';
import User from './components/User';
import Admin from './components/Admin';
import Logout from './components/Logout';
// import Support from './components/support';
import Layout from './components/Layout';
import PrivateRoute from './components/PrivateRoute';
import firebaseConfig from './firebaseConfig';

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/PhoneAuth" element={<PhoneAuth auth={firebase.auth()} />} />
          <Route path="/" element={<Login />} />
          {/* <Route path="/support" element={<Support />} /> */}
          <Route element={<Layout />}>
            <Route path="/Enquiry-1" element={<PrivateRoute component={Enquiry1} />} />
            <Route path="/Enquiry-2" element={<PrivateRoute component={Enquiry2} />} />
            <Route path="/User" element={<PrivateRoute component={User} />} />
            <Route path="/Admin" element={<PrivateRoute component={Admin} />} />
            {/* <Route path="/PhoneAuth" element={<PrivateRoute component={PhoneAuth} auth={firebase.auth()} />} /> */}
            <Route path="/Logout" element={<Logout />} />
          </Route>
        </Routes>
      </div>
    </Router>
  );
}

export default App;







//normal
// src/App.js
// import React from 'react';
// import './App.css';
// import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
// import PhoneAuth from './components/PhoneAuth';
// import Login from './components/PhoneLogin';
// // import Home from './components/Home';
// import Enquiry1 from './components/Enquiry-1';
// import Enquiry2 from './components/Enquiry-2';
// import User from './components/User';
// import Logout from './components/Logout';
// // import Support from './components/support';
// import Layout from './components/Layout';
// import PrivateRoute from './components/PrivateRoute';
// import firebase from './firebase'; // Import initialized Firebase instance

// function App() {
//   return (
//     <Router>
//       <div className="App">
//         <Routes>
//           <Route path="/PhoneAuth" element={<PhoneAuth auth={firebase.auth()} />} />
//           <Route path="/" element={<Login />} />
//           {/* <Route path="/support" element={<Support />} /> */}
//           <Route element={<Layout />}>
//             <Route path="/Enquiry-1" element={<PrivateRoute component={Enquiry1} />} />
//             <Route path="/Enquiry-2" element={<PrivateRoute component={Enquiry2} />} />
//             <Route path="/User" element={<PrivateRoute component={User} />} />
//             {/* <Route path="/PhoneAuth" element={<PrivateRoute component={PhoneAuth} auth={firebase.auth()} />} /> */}
//             <Route path="/Logout" element={<Logout />} />
//           </Route>
//         </Routes>
//       </div>
//     </Router>
//   );
// }

// export default App;

